import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EventTextProps } from './EventText';
import StyledEventText from './StyledEventText';

const EventTextEmpty: React.FC<EventTextProps> = ({ matchEvent }) => {
  const team = matchEvent?.team?.name;

  return (
    <StyledEventText>
      <FormattedMessage id={`eventText.${matchEvent.matchEventTypeId}.empty`} values={{ team }} />
    </StyledEventText>
  );
};

export default EventTextEmpty;
